
import { Component, Vue, Emit, Watch } from "vue-property-decorator";
import store from "@/store";
import { fetchMghrwcToken, fetchSid } from "@/services/userService";
import BoxError, { ErrorText } from "@/components/box/BoxError/BoxError.vue";

@Component({
  components: {
    BoxError,
  },
})
export default class ToMghrwc extends Vue {
  private error: ErrorText | null = null;

  @Emit()
  private handlerClickBtn() {
    const token = store.getters["auth/token"];
    if (token) {
      this.$router.push({
        path: token ? "/" : "/login",
        replace: true,
      });
    }
  }

  private async created() {
    const rawRedirect = this.$route.query.redirect;
    const redirectUrl = Array.isArray(rawRedirect)
      ? rawRedirect[0]
      : rawRedirect;
    if (!redirectUrl) {
      this.error = { title: "不正なURLです" };
      return;
    }
    const encodedUrl = encodeURIComponent(redirectUrl);

    const mghrwc = store.getters["auth/mghrwc"];
    if (!mghrwc) {
      window.location.href = encodedUrl;
    }

    try {
      const { token, id } = await fetchMghrwcToken({
        action: "clubno",
        lang: "ja-JP",
      })
      .catch((error) => {
          console.error(error);
          throw error;
      });

      /**
       * SSOトークン取得API
       */
      let sid = "";
      try {
        sid = await fetchSid({
          token,
          clubno: mghrwc.clubno,
        });
      } catch (error) {
        console.error(error);
        this.error = { title: "システムエラー", message: "お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。" };
        return;
      }

      if (!sid) {
        this.error = { title: "システムエラー", message: "お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。" };
        return;
      }

      const mghrwcSSOUrl = `${process.env.VUE_APP_OPTIMA_RESERVATION_URL}/ja/external/members/login?lang=ja-JP&page=top&CLUBNO=${mghrwc.clubno}&SID=${sid}&rurl=${encodedUrl}`;
      window.location.replace(mghrwcSSOUrl);
      return;
    } catch (error) {
      console.error(error);
      this.error = { title: "システムエラー", message: "お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。" };
      return;
    }

  }

  @Watch("error")
  private changeErrorState(newVal: boolean) {
    if (this.error) {
      store.commit("loaded", true);
    }
  }

  private async mounted() {
    const mghrwcUser = store.getters["auth/mghrwc"];
  }
}
